import React from 'react';
import EditSectionLabel from './EditSectionLabel';
import EditSectionInput from './EditSectionInput';
import EditSectionTextArea from './EditSectionTextArea';
import EditSectionDateTime from './EditSectionDateTime';
import EditSectionDropdown from './EditSectionDropdown';

import {
  MultiLevelGrid,
  MultiLevelGridHeader,
  MultiLevelGridHeaderColumn,
  MultiLevelGridRow,
  MultiLevelGridBody
} from './MultiLevelGrid';


// View child rows for an item
class ChildRowsDialog extends React.Component {

  constructor( props ){
    super( props );
    this.state = {
      layout: this.props.layout === undefined ? {} : this.props.layout,
      show: this.props.show === undefined ? false : this.props.show,
      title: this.props.title === undefined ? '[No Title]' : this.props.title,
      newitem: this.props.newitem === undefined ? {'title':'No Title'} : this.props.newitem,
      headers: this.props.headers === undefined ? [] : this.props.headers,
      rows: this.props.rows === undefined ? [] : this.props.rows,
      optionstore: this.props.optionstore === undefined ? {} : this.props.optionstore
    };
  }

  componentWillReceiveProps( nextProps ){
    this.setState( {
      layout: nextProps.layout === undefined ? {} : nextProps.layout,
      show: nextProps.show,
      title: nextProps.title === undefined ? '[No Title]' : nextProps.title,
      newitem: nextProps.newitem === undefined ? {'title':'No Title'} : nextProps.newitem,
      headers: nextProps.headers === undefined ? [] : nextProps.headers,
      rows: nextProps.rows === undefined ? [] : nextProps.rows,
      optionstore: nextProps.optionstore === undefined ? {} : nextProps.optionstore
    } );
  }

  //** COMPONENT EVENTS **//
  onDelete( args, e ){
    if( this.props.onDelete !== undefined ){
      this.props.onDelete( args, e );
    }
  }

  onChangeSubItem( args, e ){
    if( this.props.onChange !== undefined ) {
      this.props.onChange( args, e );
    }
  }

  //* COMPONENT UTILITY FUNCTIONS **//
  createDialogControl( rowindex, field, item, mode ) {
    let type = 'label';
    let column = '';
    let width = '100%';
    let precision = 0;
    let canedit = true;
    let options = [];
    let routes = {};
    let routekey = '';
    let maxLength = '524288';

    let isNew = mode === 'NEW' ? true : false;

    for( var key in Object.keys( field ) ) {

      let property = Object.keys( field )[key];

      if( property === 'type' ){
        type = field.type;
      }

      if( property === 'column' ){
        column = field.column;
      }

      if( property === 'width' ){
        width = field.width;
      }

      if( property === 'canedit' ){
        canedit = field.canedit;
      }

      if( property === 'precision' ){
        precision = field.precision;
      }

      if( property === 'options' ){
        options = field.options;
      }

      if( property === 'routes' ){
        routes = field.routes;
        routekey = routes.routekey;
      }
      if( property === 'maxLength' ){
        maxLength = field.maxLength;
      }

    }

    let args = { 'column': column, 'rowindex': rowindex };
    let onChangeItemEvent = this.onChangeSubItem.bind( this, args );
    let rowkey = 'list-container-input-row-' + type.toLowerCase() + '-' + column.toLowerCase() + '-' + rowindex.toString();
    let value = item[column];

    if( value === undefined ){
      value='';
    }

    if( typeof( value ) === 'object' ) {
      if( maxLength ) {
        value = value.slice( 0, Number( maxLength ) );
      }
    }

    //** CREATE DEFAULT LABEL **//
    let inputcontrol = (
      <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
        <EditSectionLabel id={column} column={column} Text={value} width={width} hilite />
      </span>
    );

    if( isNew === true || canedit === true ) {

      //** CREATE TEXTOX CONTROL **//
      if( type === 'textbox' ){
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionInput id={column} column={column} value={value} width={width} onChanged={onChangeItemEvent} />
          </span>
        );
      }

      //** CREATE NUMERIC CONTROL **//
      if( type === 'numerictextbox' ) {
        value = parseFloat( value ).toFixed( precision );
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionInput id={column} column={column} value={value} width={width} onChanged={onChangeItemEvent} />
          </span>
        );
      }

      //** CREATE TEXTAREA CONTROL **//
      if( type === 'textarea' ){
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionTextArea id={column} column={column} value={value} width={width} onChanged={onChangeItemEvent} />
          </span>
        );
      }

      //** CREATE DATE PICKER CONTROL **//
      if( type === 'date' ){
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionDateTime id={column} column={column} value={value} width={width} onChange={onChangeItemEvent} timeFormat={false} />
          </span>
        );
      }

      //** CREATE DATE PICKER CONTROL **//
      if( type === 'time' ){
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionDateTime id={column} column={column} value={value} width={width} onChange={onChangeItemEvent} dateFormat={false} />
          </span>
        );
      }

      //** CREATE DROPDOWN CONTROL **//
      if( type === 'dropdown' ){
        let store = this.state.optionstore;
        let options = [];
        if( ( routekey !== undefined ) || ( routekey !== '' ) ){
          options = store[routekey];
        }
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionDropdown id={column} column={column} options={options} value={value} width={width} onChanged={onChangeItemEvent} />
          </span>
        );
      }

      //** CREATE STATIC DROPDOWN **//
      if( type === 'staticdropdown' ) {
        inputcontrol = (
          <span key={rowkey} style={{'paddingRight':'5px','width':'100%'}}>
            <EditSectionDropdown id={column} column={column} options={options} value={value} width={width} onChanged={onChangeItemEvent} />
          </span>
        );
      }
    }
    return ( inputcontrol );
  }

  //** RENDER FUNCTIONS **//
  onRenderHeaders(){
    let headers = this.state.headers;
    let gridheaders = [];
    if( headers.length > 0 ){
      gridheaders = headers.map( ( header, index ) => {
        let headerkey = 'list-container-detail-view-grid-dialog-header-' + index.toString() + '-' + header.column.toLowerCase();
        return (
          <MultiLevelGridHeaderColumn key={headerkey} column={header.column} text={header.label} width={header.width} />
        );
      } );
    }
    return ( gridheaders );
  }

  onRenderRows() {

    let gridrows = this.state.rows;
    let headers = this.state.headers;
    let rows = [];
    let viewablerows = 0;

    if( gridrows !== undefined ) {
      if( gridrows.length > 0 ) {
        for( var rowindex = 0; rowindex < gridrows.length; rowindex++ ) {
          const row = rows[ rowindex ];
          let rowkey = 'list-container-detail-view-grid-dialog-row-' + rowindex.toString();
          let deletekey = 'list-container-detail-view-grid-dialog-row-delete-' + rowindex.toString();
          let gridrow = [];
          if( row && row.mode !== 'DELETE' ) {
            viewablerows += 1;
            for( var headerindex = 0; headerindex < headers.length; headerindex++ ) {
              const header = headers[ headerindex ];
              gridrow.push( this.createDialogControl( rowindex, header, row, row.mode ) );
            }
            let args = { rowindex: rowindex - 1 };
            rows.push(
              <MultiLevelGridRow key={rowkey} nodivider>
                {gridrow}
                <button key={deletekey} className="list-container-detail-view-grid-dialog-delete-button" onClick={this.onDelete.bind( this, args )}>
                  <i className="icon-nargela-trash-bin" />
                </button>
              </MultiLevelGridRow>
            );
          }
          let args = { rowindex: rowindex - 1 };
          rows.push(
            <MultiLevelGridRow key={rowkey} nodivider>
              {gridrow}
              <button key={deletekey} className="list-container-detail-view-grid-dialog-delete-button" onClick={this.onDelete.bind( this, args )}>
                <i className="icon-nargela-trash-bin" />
              </button>
            </MultiLevelGridRow>
          );
        }
      } else {
        if( viewablerows === 0 ) {
          rows.push(
            <EditSectionLabel key="noRecordsLabel" Text="There were no records found." />
          );
        }
      }
    } else {
      rows.push(
        <EditSectionLabel key="noRecordsLabel" Text="There were no records found." />
      );
    }
    return ( rows );
  }

  onRenderGrid(){

    let bodyStyles =
      {
        'marginRight':'-10px',
        'overflowX':'hidden',
        'maxHeight': '500px',
        'height': '500px',
        'width':'100%'
      };

    return (
      <MultiLevelGrid style={{'width':'100%','height':'100%'}} >
        <MultiLevelGridHeader>
          <span className="list-container-grid-view-dialog-header">
            <button className="list-container-grid-view-dialog-new-button" onClick={this.props.onNew}>Add New {this.state.newitem.title}</button>
          </span>
        </MultiLevelGridHeader>
        <MultiLevelGridHeader>
          {this.onRenderHeaders()}
        </MultiLevelGridHeader>
        <div style={bodyStyles}>
          <MultiLevelGridBody>
            {this.onRenderRows()}
          </MultiLevelGridBody>
        </div>
      </MultiLevelGrid>
    );
  }

  render(){

    if( this.state.show === true ) {
      return (
        <div className="child-rows-dialog">
          <div className="child-rows-dialog-header">
            {this.state.title}
            <span className='child-rows-dialog-close-button' onClick={this.props.onCancel} >
              <i className="icon-fontello-cancel" />
            </span>
          </div>
          <div className="child-rows-dialog-body">
            {this.onRenderGrid()}
          </div>
          <div className="child-rows-dialog-footer">
            <button className='child-rows-dialog-confirm-button' key='btnSaveGrid' onClick={this.props.onSave}>Save</button>
            <button className='child-rows-dialog-cancel-button' key='btnCancelGrid' onClick={this.props.onCancel}>Cancel</button>
          </div>
        </div>
      );
    } else {
      return (
        <span></span>
      );
    }
  }
}

export default ChildRowsDialog;



// WEBPACK FOOTER //
// ./src/presentation/ChildRowsDialog.js